import { TextField } from '@mui/material';
import { FilterDropdown } from 'components/tailwind-ui/FilterDropdown';
import { UnwatchedState } from 'pages/Shipments/Containers/types';
import * as React from 'react';
import { useFilterSearchParams } from '../../../utilities';

export const BillOfLading: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const [bol, setBol] = React.useState<string>(searchParams.billOfLadingNumbers ?? '');

  React.useEffect(() => {
    setBol(searchParams.billOfLadingNumbers[0] ?? '');
  }, [searchParams]);

  return (
    <FilterDropdown
      label="Ocean BOL"
      count={searchParams.billOfLadingNumbers.length}
      clear={() => setSearchParams({ billOfLadingNumbers: [], unwatchedState: null })}
    >
      {({ close }) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSearchParams({
              billOfLadingNumbers: [bol],
              unwatchedState: UnwatchedState.WatchedAndUnwatched,
            });
            close();
          }}
          className="px-3 py-2"
        >
          <TextField
            className="w-[285px]"
            variant="outlined"
            size="small"
            placeholder="Filter by ocean BOL (XXXX1234567)"
            fullWidth
            onChange={(e) => setBol(e.target.value)}
            value={bol}
          />
        </form>
      )}
    </FilterDropdown>
  );
};
BillOfLading.displayName = 'Shipments.Filters.BillOfLading';
